import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewPersonal = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'personal',
        name: 'Personal',
        component: ViewPersonal,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
